import { useState } from 'react'
import { MoonStar } from 'lucide-react'
import { siteConfig } from '../config/site'

export function LogoMark({ compact = false, eager = false }) {
  const [imageAvailable, setImageAvailable] = useState(true)

  return (
    <span className={`logo-mark ${compact ? 'logo-mark--compact' : ''}`}>
      {imageAvailable && (
        <img
          className="logo-mark__image"
          src={siteConfig.logoPath}
          alt=""
          width="48"
          height="48"
          loading={eager ? 'eager' : 'lazy'}
          fetchPriority={eager ? 'high' : 'auto'}
          decoding="async"
          onError={() => setImageAvailable(false)}
        />
      )}
      {!imageAvailable && (
        <span className="logo-mark__fallback" aria-hidden="true">
          <MoonStar size={compact ? 20 : 25} strokeWidth={1.55} />
        </span>
      )}
      <span className="logo-mark__wordmark">
        <strong>The Midnight</strong>
        <span>Sanctuary</span>
      </span>
    </span>
  )
}
